// extracted by mini-css-extract-plugin
export default {"root":"HVkmzK","dropdownButton":"dq9xit","dropdownMenu":"BOya2d","avatar":"MD98aq","loginBtn":"aGjjZM","text":"LckE0z"};